export default "__VITE_ASSET__BZziLnHs__"